import React from 'react';

export function LandingDisclaimer() {
  return (
    <div
      className="text-center"
      style={{
        backgroundColor: 'rgba(255,255,255,0.02)',
        padding: '20px',
        borderTop: '0.5px solid rgba(255,255,255,0.04)',
      }}
    >
      <p
        className="max-w-3xl mx-auto leading-relaxed"
        style={{ fontSize: 11, color: 'rgba(244,241,234,0.35)' }}
      >
        MyCryptoPlanner is a planning and estimation tool. It is not a substitute
        for professional financial or tax advice. Always consult a qualified
        accountant before filing your tax return.
      </p>
    </div>
  );
}
